module.exports = __webpack_public_path__ + "static/img/8.9857f9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/8.png
// module id = Pw/B
// module chunks = 0